import { render, staticRenderFns } from "./ItemActionStatsEmit.vue?vue&type=template&id=7cfbcff2&scoped=true&"
import script from "./ItemActionStatsEmit.vue?vue&type=script&lang=js&"
export * from "./ItemActionStatsEmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfbcff2",
  null
  
)

export default component.exports